import APIService from '../api.service';

const PriceService = {
  FetchPriceList: (params) => {
    return APIService.get('/v01/price-list', { params });
  },
  FetchPriceHistory: (params) => {
    return APIService.get('/v01/price-histories', { params });
  },
  ChangePrice: (data) => {
    return APIService.post('/v01/change-price', data);
  },
  ExportPriceList: (params) => {
    return APIService.get('/v01/price-list/export', { params });
  },
  ImportPriceList: (formData) => {
    return APIService.post('/v01/price-list/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  FetchStandardCostRevaluations: (params) => {
    return APIService.get('/v01/standard-cost-revaluations', { params });
  },
};

export default PriceService;
